export enum MaintenanceState {
  Upcoming = 'upcoming',
  InProgress = 'in-progress',
}

/**
 * Global maintenance notice, delivered on /api/me. Driven by the
 * MAINTENANCE_BANNER_* waffle switches — the switch note is the copy.
 */
export interface MaintenanceNotice {
  state: MaintenanceState
  message: string
}
